import PropTypes from 'prop-types';
import React from 'react';

import AllbirdsByNature from 'components/Icon/AllbirdsByNature';
import ResponsiveImage from 'components/ResponsiveImage';
import RichText from 'components/RichText';
import { IMAGE_WIDTHS } from 'constants/images';
import { cn } from 'utils/Tailwind';

function PageSectionStatementTextModule({ asset, assetMobile, body, isInverted, title }) {
  return (
    <div className="relative my-10 text-center">
      {asset && assetMobile && (
        <ResponsiveImage
          className="absolute inset-0 h-full w-full"
          mobileSrc={assetMobile.file.url}
          desktopSrc={asset.file.url}
          mobileWidth={IMAGE_WIDTHS.W_1600}
          mobileHeight={IMAGE_WIDTHS.W_2000}
          desktopWidth={IMAGE_WIDTHS.W_2800}
          desktopHeight={IMAGE_WIDTHS.W_1000}
          coverParentNode
          lazy
        />
      )}

      <ModuleContent
        asset={asset}
        assetMobile={assetMobile}
        body={body}
        isInverted={isInverted}
        title={title}
      />
    </div>
  );
}

function ModuleContent({ body, isInverted, title }) {
  return (
    <div
      className={cn('relative z-10 flex flex-col items-center justify-center p-6 md:p-20', {
        'text-white': isInverted,
      })}
    >
      {title && (
        <h2 className="mb-6 text-base font-medium uppercase tracking-wider lg:text-2xl">{title}</h2>
      )}
      {body && <RichText content={body} className="mx-auto max-w-3xl [&>p]:lg:!text-lg" />}
      <AllbirdsByNature className="h-12 w-[100px]" />
    </div>
  );
}

ModuleContent.propTypes = {
  body: PropTypes.object,
  ctaLinks: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  isInverted: PropTypes.bool,
  title: PropTypes.string,
  trackCTAClick: PropTypes.func,
};

ModuleContent.defaultProps = {
  asset: null,
  assetMobile: null,
  body: null,
  ctaLinks: [],
  title: '',
};

PageSectionStatementTextModule.propTypes = {
  asset: PropTypes.shape({
    description: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string,
      contentType: PropTypes.string,
    }),
  }),
  assetMobile: PropTypes.shape({
    description: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string,
      contentType: PropTypes.string,
    }),
  }),
  body: PropTypes.object,
  isInverted: PropTypes.bool,
  title: PropTypes.string,
};

PageSectionStatementTextModule.defaultProps = {
  body: null,
  ctaLinks: [],
  title: '',
};

export default PageSectionStatementTextModule;
